import { QuestDefinition } from './types';

/**
 * Quest definition for the Wall Edit tool (WallEditTool / 'wall_edit').
 *
 * Same hint flow as the full wall sketch editor, minus the extrude gesture —
 * creation is stripped from this tool (grabbing an unselected element moves
 * it instead of extruding).
 */
export const wallEditQuest: QuestDefinition = {
  toolName: 'wall_edit',
  states: {
    editing: 'editing — drag to move · Delete to remove · Enter to save · Esc to cancel · Shift = nodes only · Ctrl = no snap',
  },
  defaultKey: 'click a node or wall to start editing',
};
